const states = {
  upSpecil: [],
  chooseUpSpecil: '',    // 选中的营地sku
  campAddress: '',       // 营地期地址
  campTotalAddress: '',   // 营地详细地址
  campDetailInfo: {},     // 选择的具体信息
  isSellOut: false,       // 是否售罄
  swiperPage: {
    total: 0,
    current: 0,
  }
};
export default states;
